import {useEffect, useMemo, useState} from "react";
import "./LiveRace.scss";
import combinedServices from "../../shared/services/user-service";
import userConstants from "../../shared/constants/user-constants";
import { io } from "socket.io-client";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { FaFlagCheckered } from "react-icons/fa";

const LiveRace = ({
  heatNumber,
  classId,
  eventDetail
}) => {

  const [eventId, setEventId] = useState(eventDetail?.event_id);
  const [fetchScoreAgain, setFetchScoreAgain] = useState(true);
  const [className, setClassName] = useState("");
  const [scores, setScores] = useState([]);
  const [round, setRound] = useState("");

  // Memoize socket connection
  const socket = useMemo(() => io.connect(userConstants.baseURL), []);

  // Socket event listeners
  useEffect(() => {
    
    const handleScoreUpdate = (data) => { 
      console.log("🚀 ~ score update event received:", data)
      setFetchScoreAgain(prev => !prev); // Toggle to trigger score refetch
    }

    socket.on("driverCheckIn", handleScoreUpdate);
    socket.on("penaltyAddedEvent", handleScoreUpdate);
    socket.on("driverDisqualifiedManually", handleScoreUpdate);
    socket.on("removeDisqualification", handleScoreUpdate);
    socket.on("lapProcessed", handleScoreUpdate);
    socket.on("penaltyRemovedEvent", handleScoreUpdate);
    socket.on("participantStatusChange", handleScoreUpdate);
    socket.on("goodStartMark", handleScoreUpdate);

    return () => {
      socket.off("driverCheckIn", handleScoreUpdate);
      socket.off("penaltyAddedEvent", handleScoreUpdate);
      socket.off("driverDisqualifiedManually", handleScoreUpdate);
      socket.off("removeDisqualification", handleScoreUpdate);
      socket.off("lapProcessed", handleScoreUpdate);
      socket.off("penaltyRemovedEvent", handleScoreUpdate);
      socket.off("participantStatusChange", handleScoreUpdate);
      socket.off("goodStartMark", handleScoreUpdate);
      socket.disconnect();
    };
  }, [eventId, socket]);

  useEffect(() => {
    if (eventDetail?.event_id) {
      setEventId(eventDetail.event_id);
    }
  }, [eventDetail]);


  useEffect(()=>{
    const fetchLiveScore = async () => {
      if (!heatNumber || !classId) return;
      try {
        const heatScoreResponse = await combinedServices.getHeatScore({
          eventId,
          classId,
          heatNumber,
        });
        if (heatScoreResponse?.data) {
          setClassName(heatScoreResponse?.data?.classname);
          setRound(heatScoreResponse?.data?.round);
          const liveScoreResponse = await combinedServices.getLiveMyLapScore({
            eventId,
            classId,
            heatNumber,
            round: heatScoreResponse?.data?.round,
          });
          if(liveScoreResponse.status==200){
            setScores(liveScoreResponse.data);
          }
        }
      } catch (err) {
        console.error("Error fetching heat score:", err);
      }
    };

    fetchLiveScore();
  }, [eventId, classId, heatNumber, fetchScoreAgain]);

  // const raceData = [
  //   { pos: 1, driver: "Driver A", totalLaps: 7, penalties: 0, goodLaps: 7 },
  //   { pos: 2, driver: "Driver D", totalLaps: 6, penalties: 1, goodLaps: 5 },
  //   { pos: 3, driver: "Driver B", totalLaps: 5, penalties: 0, goodLaps: 5 },
  //   { pos: 4, driver: "Driver C", totalLaps: 5, penalties: 1, goodLaps: 5 },
  //   { pos: 5, driver: "Driver E", totalLaps: 4, penalties: 0, goodLaps: 4 },
  //   { pos: 6, driver: "Driver F", totalLaps: 3, penalties: 2, goodLaps: 1 },
  // ];

  return (
    <div className="race-positions">
      <div className="race-positions__header">R{round} H{heatNumber} {className}</div>
      <table className="race-positions__table">
        <thead>
          <tr>
            <th className="pos">POS</th>
            <th>DRIVER</th>
            {/* <th>TOTAL LAPS</th> */}
            <th>PENALTIES</th>
            <th>LAPS</th>
          </tr>
        </thead>
        <tbody>
          {/* {raceData.map((row) => (
            <tr key={row.pos}>
              <td className="pos">{row.pos}</td>
              <td>{row.driver}</td>
              <td>{row.totalLaps}</td>
              <td className={row.penalties > 0 ? "penalty" : ""}>{row.penalties}</td>
              <td>{row.goodLaps}</td>
            </tr>
          ))} */}
          {
            scores.map((score, index) => {
              const isDisqualified = ["DQ", "DNS", "DNF"].includes(score.driver_status);

              return (
                <tr key={index}>
                  <td className="pos">{score.finish_position}</td>

                  <td className={isDisqualified ? "status" : ""}>
                    {score.driver.user_firstname + " " + score.driver.user_lastname}
                  </td>
                  {/* <td>{score.total_laps}</td> */}
                  {isDisqualified ? (
                    <>
                      <td className="status">
                        {score.driver_status}
                      </td>
                      <td className="status">
                        {score.driver_status}
                      </td>
                    </>
                  ) : (
                    <>
                      <td className={score.penalty_count > 0 ? "penalty" : ""}>
                        {score.penalty_count}
                      </td>
                      <td>{score.good_laps > 5 ? <FaFlagCheckered /> : score.total_laps}</td>
                    </>
                  )}
                </tr>
              );
            })
          }
        </tbody>
      </table>
    </div>
  );
};

export default LiveRace;
